(function() {
  var __indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

  vtex.define('shipping/script/mixin/withCreateMap',['shipping/script/module/googleRequiredFields'], function(checkRequiredFields) {
    return function() {
      checkRequiredFields = checkRequiredFields;
      this.createMap = function() {
        var location, mapOptions, markerOptions, _ref, _ref1,
          _this = this;
        if (((_ref = this.attr.data.address) != null ? (_ref1 = _ref.geoCoordinates) != null ? _ref1.length : void 0 : void 0) === 2) {
          this.select('mapCanvasSelector').css('display', 'block');
          if (this.attr.map) {
            this.attr.map = null;
          }
          if (this.attr.marker) {
            this.attr.marker.setMap(null);
            this.attr.marker = null;
          }
          location = new google.maps.LatLng(this.attr.data.address.geoCoordinates[1], this.attr.data.address.geoCoordinates[0]);
          mapOptions = {
            zoom: 15,
            center: location,
            streetViewControl: false,
            mapTypeControl: false,
            zoomControl: true,
            zoomControlOptions: {
              position: google.maps.ControlPosition.TOP_RIGHT,
              style: google.maps.ZoomControlStyle.SMALL
            }
          };
          this.attr.map = new google.maps.Map(document.getElementById('map-canvas'), mapOptions);
          markerOptions = {
            position: location,
            draggable: true,
            map: this.attr.map
          };
          this.attr.marker = new google.maps.Marker(markerOptions);
          return this.attr.markerListener = google.maps.event.addListener(this.attr.marker, 'position_changed', _.debounce((function() {
            var newPosition;
            newPosition = _this.attr.marker.getPosition();
            return _this.changeMarkerPosition(newPosition);
          }), 1500));
        }
      };
      return this.changeMarkerPosition = function(newPosition) {
        var _this = this;
        if (!this.attr.geocoder) {
          this.attr.geocoder = new google.maps.Geocoder();
        }
        return this.attr.geocoder.geocode({
          location: newPosition
        }, (function(results, status) {
          var address, countryRules, fallbackCountry, googleAddress, googleDataMap, postalCodeRegex, storeAcceptsGeoCoords, _ref;
          if (status === google.maps.GeocoderStatus.OK) {
            if (results[0]) {
              countryRules = _this.getCountryRule();
              googleAddress = results[0];
              postalCodeRegex = countryRules.regexes['postalCode'];
              googleDataMap = countryRules.googleDataMap;
              fallbackCountry = countryRules.country;
              storeAcceptsGeoCoords = (__indexOf.call((_ref = _this.attr.data.logisticsConfiguration) != null ? _ref.acceptSearchKeys : void 0, 'geoCoords') >= 0);
              address = _this.getAddressFromGoogle(googleAddress, googleDataMap, fallbackCountry);
              _this.attr.data.address.geoCoordinates = address.geoCoordinates;
              _this.attr.data.address.neighborhood = address.neighborhood || _this.attr.data.address.neighborhood;
              _this.attr.data.address.state = address.state || _this.attr.data.address.state;
              _this.attr.data.address.city = address.city || _this.attr.data.address.city;
              _this.attr.data.address.street = address.street || _this.attr.data.address.street;
              _this.attr.data.address.number = address.number || _this.attr.data.address.number;
              _this.attr.data.address.postalCodeIsValid = postalCodeRegex.test(address.postalCode);
              _this.attr.data.address.geoCoordinatesIsValid = address.geoCoordinates.length === 2;
              _this.trigger('addressKeysUpdated.vtex', [_this.attr.data.address]);
              return _this.render();
            }
          } else {
            return console.log('Google Maps: ' + status);
          }
        }));
      };
    };
  });

}).call(this);

